import React from 'react'

export default _ => (<div className="shadow-card" />)


// WEBPACK FOOTER //
// ./src/components/adminuser/shadowcard.jsx